var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _path, _rect11, _rect12, _path2, _rect13, _rect14, _rect15, _rect16, _rect17, _path3, _rect18, _path4, _rect19, _path5, _rect20, _path6, _path7, _path8, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRiderFriendly(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 652,
    height: 452,
    viewBox: "0 0 652 452",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 651.04,
    height: 451.451,
    rx: 4,
    fill: "#21232B"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 53.2246,
    width: 175.828,
    height: 398.228,
    fill: "#020203",
    fillOpacity: 0.2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 14.2566,
    y: 90.291,
    width: 148.266,
    height: 15.2068,
    rx: 1.9067,
    fill: "white",
    fillOpacity: 0.03
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 14.2566,
    y: 67.4805,
    width: 38.0169,
    height: 15.2068,
    rx: 1.9067,
    fill: "white",
    fillOpacity: 0.03
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 14.2566,
    y: 181.531,
    width: 141.613,
    height: 15.2068,
    rx: 1.9067,
    fill: "white",
    fillOpacity: 0.03
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 14.2566,
    y: 204.34,
    width: 145.415,
    height: 15.2068,
    rx: 1.9067,
    fill: "white",
    fillOpacity: 0.03
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 14.2566,
    y: 227.152,
    width: 112.15,
    height: 15.2068,
    rx: 1.9067,
    fill: "white",
    fillOpacity: 0.03
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 14.2566,
    y: 113.1,
    width: 109.299,
    height: 15.2068,
    rx: 1.9067,
    fill: "white",
    fillOpacity: 0.03
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 14.2566,
    y: 135.91,
    width: 124.506,
    height: 15.2068,
    rx: 1.9067,
    fill: "white",
    fillOpacity: 0.03
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 14.2566,
    y: 158.721,
    width: 87.439,
    height: 15.2068,
    rx: 1.9067,
    fill: "white",
    fillOpacity: 0.03
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H647.04C649.249 0 651.04 1.79086 651.04 4V53.2237H0V4Z",
    fill: "#141519"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 175.829,
    y: 114.051,
    width: 475.212,
    height: 57.0254,
    fill: "white",
    fillOpacity: 0.02
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 175.829,
    y: 357.359,
    width: 476.162,
    height: 57.0254,
    fill: "white",
    fillOpacity: 0.02
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M175.829 418.188H651.041V447.452C651.041 449.661 649.25 451.452 647.041 451.452H175.829V418.188Z",
    fill: "white",
    fillOpacity: 0.02
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 175.829,
    y: 174.877,
    width: 475.212,
    height: 57.0254,
    fill: "white",
    fillOpacity: 0.02
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 175.829,
    y: 235.705,
    width: 475.212,
    height: 57.0254,
    fill: "white",
    fillOpacity: 0.02
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 175.829,
    y: 53.2246,
    width: 475.212,
    height: 57.0254,
    fill: "white",
    fillOpacity: 0.02
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 175.829,
    y: 296.533,
    width: 475.212,
    height: 57.0254,
    fill: "white",
    fillOpacity: 0.02
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 175.829,
    y: 53.2246,
    width: 158.721,
    height: 57.0254,
    rx: 1.43003,
    fill: "#FCFCFC",
    fillOpacity: 0.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M259.02 82.0036H258.47V79.2518C258.47 76.7914 257.01 75 255 75C252.99 75 251.53 76.7914 251.53 79.2518V82.0036H250.98C250.44 82.0036 250 82.4784 250 83.0612V88.9424C250 89.5252 250.44 90 250.98 90H259.02C259.56 90 260 89.5252 260 88.9424V83.0612C260 82.4784 259.56 82.0036 259.02 82.0036ZM252.53 79.2518C252.53 77.3849 253.54 76.0791 255 76.0791C256.46 76.0791 257.47 77.3849 257.47 79.2518V82.0036H252.54V79.2518H252.53ZM251 88.9424L250.98 83.0827H259L259.02 88.9209L251 88.9424Z",
    fill: "#FCFCFC",
    fillOpacity: 0.2
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 279,
    y: 114,
    width: 158.721,
    height: 57.0254,
    rx: 1.43003,
    fill: "#FCFCFC",
    fillOpacity: 0.1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M361.02 142.004H360.47V139.252C360.47 136.791 359.01 135 357 135C354.99 135 353.53 136.791 353.53 139.252V142.004H352.98C352.44 142.004 352 142.478 352 143.061V148.942C352 149.525 352.44 150 352.98 150H361.02C361.56 150 362 149.525 362 148.942V143.061C362 142.478 361.56 142.004 361.02 142.004ZM354.53 139.252C354.53 137.385 355.54 136.079 357 136.079C358.46 136.079 359.47 137.385 359.47 139.252V142.004H354.54V139.252H354.53ZM353 148.942L352.98 143.083H361L361.02 148.921L353 148.942Z",
    fill: "#FCFCFC",
    fillOpacity: 0.2
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 380,
    y: 176,
    width: 158.721,
    height: 57.0254,
    rx: 1.43003,
    fill: "#FCFCFC",
    fillOpacity: 0.1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M462.02 204.004H461.47V201.252C461.47 198.791 460.01 197 458 197C455.99 197 454.53 198.791 454.53 201.252V204.004H453.98C453.44 204.004 453 204.478 453 205.061V210.942C453 211.525 453.44 212 453.98 212H462.02C462.56 212 463 211.525 463 210.942V205.061C463 204.478 462.56 204.004 462.02 204.004ZM455.53 201.252C455.53 199.385 456.54 198.079 458 198.079C459.46 198.079 460.47 199.385 460.47 201.252V204.004H455.54V201.252H455.53ZM454 210.942L453.98 205.083H462L462.02 210.921L454 210.942Z",
    fill: "#FCFCFC",
    fillOpacity: 0.2
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 468,
    y: 236,
    width: 158.721,
    height: 57.0254,
    rx: 1.43003,
    fill: "#FCFCFC",
    fillOpacity: 0.1
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M550.02 264.004H549.47V261.252C549.47 258.791 548.01 257 546 257C543.99 257 542.53 258.791 542.53 261.252V264.004H541.98C541.44 264.004 541 264.478 541 265.061V270.942C541 271.525 541.44 272 541.98 272H550.02C550.56 272 551 271.525 551 270.942V265.061C551 264.478 550.56 264.004 550.02 264.004ZM543.53 261.252C543.53 259.385 544.54 258.079 546 258.079C547.46 258.079 548.47 259.385 548.47 261.252V264.004H543.54V261.252H543.53ZM542 270.942L541.98 265.083H550L550.02 270.921L542 270.942Z",
    fill: "#FCFCFC",
    fillOpacity: 0.2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M581 298.43C581 297.64 581.64 297 582.43 297H651V354H582.43C581.64 354 581 353.36 581 352.57V298.43Z",
    fill: "#FCFCFC",
    fillOpacity: 0.1
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M623.02 325.004H622.47V322.252C622.47 319.791 621.01 318 619 318C616.99 318 615.53 319.791 615.53 322.252V325.004H614.98C614.44 325.004 614 325.478 614 326.061V331.942C614 332.525 614.44 333 614.98 333H623.02C623.56 333 624 332.525 624 331.942V326.061C624 325.478 623.56 325.004 623.02 325.004ZM616.53 322.252C616.53 320.385 617.54 319.079 619 319.079C620.46 319.079 621.47 320.385 621.47 322.252V325.004H616.54V322.252H616.53ZM615 331.942L614.98 326.083H623L623.02 331.921L615 331.942Z",
    fill: "#FCFCFC",
    fillOpacity: 0.2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1920_31628)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 230.158,
    y: 210.326,
    width: 279.14,
    height: 55.828,
    rx: 2.54545,
    fill: "#C1C5DD",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.236 237.83H320.813V235.761C320.813 233.868 319.594 232.482 317.91 232.482C316.226 232.482 315.008 233.868 315.008 235.761C315.008 236.009 315.204 236.204 315.453 236.204C315.702 236.204 315.898 236.009 315.898 235.761C315.898 235.054 316.106 234.456 316.46 234.035C316.814 233.615 317.316 233.37 317.91 233.37C318.505 233.37 319.006 233.615 319.36 234.035C319.715 234.456 319.922 235.054 319.922 235.761V237.83H314.584C314.12 237.83 313.742 238.207 313.742 238.669V243.161C313.742 243.623 314.12 244 314.584 244H321.236C321.7 244 322.078 243.623 322.078 243.161V238.669C322.078 238.207 321.7 237.83 321.236 237.83ZM321.204 243.112L314.633 243.129L314.616 238.718H321.187L321.204 243.112Z",
    fill: "#020203",
    stroke: "black",
    strokeWidth: 0.0636364
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.736 242.884C333.192 242.884 332.72 242.788 332.32 242.596C331.92 242.396 331.588 242.112 331.324 241.744C331.068 241.376 330.876 240.924 330.748 240.388C330.628 239.852 330.568 239.24 330.568 238.552C330.568 237.872 330.628 237.264 330.748 236.728C330.876 236.184 331.068 235.728 331.324 235.36C331.588 234.992 331.92 234.712 332.32 234.52C332.72 234.32 333.192 234.22 333.736 234.22C334.824 234.22 335.624 234.6 336.136 235.36C336.648 236.12 336.904 237.184 336.904 238.552C336.904 239.92 336.648 240.984 336.136 241.744C335.624 242.504 334.824 242.884 333.736 242.884ZM333.736 241.6C334.016 241.6 334.252 241.548 334.444 241.444C334.636 241.332 334.788 241.176 334.9 240.976C335.02 240.776 335.104 240.532 335.152 240.244C335.208 239.948 335.236 239.62 335.236 239.26V237.832C335.236 237.112 335.124 236.544 334.9 236.128C334.684 235.712 334.296 235.504 333.736 235.504C333.176 235.504 332.784 235.712 332.56 236.128C332.344 236.544 332.236 237.112 332.236 237.832V239.272C332.236 239.992 332.344 240.56 332.56 240.976C332.784 241.392 333.176 241.6 333.736 241.6ZM339.087 242.74V234.364H342.267C343.083 234.364 343.707 234.596 344.139 235.06C344.571 235.524 344.787 236.156 344.787 236.956C344.787 237.756 344.571 238.388 344.139 238.852C343.707 239.316 343.083 239.548 342.267 239.548H340.659V242.74H339.087ZM340.659 238.264H341.943C342.367 238.264 342.671 238.18 342.855 238.012C343.039 237.836 343.131 237.56 343.131 237.184V236.728C343.131 236.352 343.039 236.08 342.855 235.912C342.671 235.736 342.367 235.648 341.943 235.648H340.659V238.264ZM347.113 242.74V234.364H352.405V235.66H348.685V237.844H352.273V239.14H348.685V241.444H352.405V242.74H347.113ZM356.376 236.728H356.256V242.74H354.912V234.364H356.844L359.04 240.376H359.16V234.364H360.504V242.74H358.572L356.376 236.728ZM374.47 235.66V242.74H372.91V235.66H370.39V234.364H376.99V235.66H374.47ZM382.904 239.14H380.456V242.74H378.884V234.364H380.456V237.844H382.904V234.364H384.476V242.74H382.904V239.14ZM387.067 242.74V234.364H392.359V235.66H388.639V237.844H392.227V239.14H388.639V241.444H392.359V242.74H387.067ZM405.557 242.884C404.837 242.884 404.221 242.76 403.709 242.512C403.205 242.264 402.793 241.936 402.473 241.528L403.421 240.544C403.733 240.904 404.069 241.172 404.429 241.348C404.797 241.516 405.189 241.6 405.605 241.6C406.085 241.6 406.453 241.492 406.709 241.276C406.965 241.06 407.093 240.748 407.093 240.34C407.093 240.004 406.997 239.752 406.805 239.584C406.613 239.408 406.289 239.284 405.833 239.212L404.945 239.068C404.169 238.932 403.617 238.652 403.289 238.228C402.961 237.796 402.797 237.288 402.797 236.704C402.797 235.904 403.057 235.292 403.577 234.868C404.097 234.436 404.817 234.22 405.737 234.22C406.393 234.22 406.957 234.324 407.429 234.532C407.909 234.74 408.293 235.024 408.581 235.384L407.657 236.368C407.433 236.104 407.165 235.896 406.853 235.744C406.541 235.584 406.173 235.504 405.749 235.504C404.837 235.504 404.381 235.88 404.381 236.632C404.381 236.952 404.477 237.196 404.669 237.364C404.861 237.532 405.189 237.656 405.653 237.736L406.529 237.892C407.257 238.028 407.797 238.296 408.149 238.696C408.501 239.096 408.677 239.608 408.677 240.232C408.677 240.624 408.609 240.984 408.473 241.312C408.337 241.632 408.137 241.912 407.873 242.152C407.609 242.384 407.281 242.564 406.889 242.692C406.505 242.82 406.061 242.884 405.557 242.884ZM411.039 242.74V234.364H416.331V235.66H412.611V237.844H416.199V239.14H412.611V241.444H416.331V242.74H411.039ZM422.414 235.66V242.74H420.854V235.66H418.334V234.364H424.934V235.66H422.414Z",
    fill: "#141519"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1920_31628",
    x: 229.522,
    y: 210.326,
    width: 280.413,
    height: 57.7372,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.27273
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.318182
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1920_31628"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1920_31628",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiderFriendly);
export default __webpack_public_path__ + "static/media/rider-friendly.96f1a2583baf5d46037d11b8741fead4.svg";
export { ForwardRef as ReactComponent };